import {FC} from 'react';

type Icon = {
    className?: string;
};

const Warning: FC<Icon> = ({className}) => (
    <svg
        width="22"
        height="25"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path d="M0 15.2H17.6L8.8 0L0 15.2ZM9.6 12.8H8V11.2H9.6V12.8ZM9.6 9.6H8V6.4H9.6V9.6Z" fill="#A50C0E" />
    </svg>
);

export default Warning;
